import { createTheme, ThemeOptions } from '@mui/material'
import { textBlue } from './components/Basic/colors'

const themeOptions: ThemeOptions = {
    palette: {
        primary: {
            main: textBlue,
            light: '#082F4D',
            dark: '#082F4D',
        },
        secondary: {
            main: '#E33E7F',
            light: '#E86498',
            dark: '#9E2B58',
        },
    },
    typography: {
        fontFamily: 'Inter',
    },
}

export const theme = createTheme(themeOptions)
